var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__ai-modal__selfie-say-cheese"},[_c('div',{staticClass:"hide--below-lg cz2__modal-popup__header"},[_vm._v(" "+_vm._s(_vm.$t('AI_SELFIE_CHEESE_HEADING'))+" ")]),_c('selfie-stream')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }